"use strict";
let ModalUserFeedback = require("@gluenetworks/modal_user_feedback");
let PopUp = require("@gluenetworks/pop_up");
let GridGl = require("@gluenetworks/grid_gl").Grid;
let DefaultColumnComponent = require("@gluenetworks/grid_gl").DefaultColumnComponent;

module.exports = {
    UserFeedback: {
        ModalUserFeedback: ModalUserFeedback.modalUserFeedback,
    },
    PopUp: PopUp,
    GridGl: {
        Grid: GridGl,
        DefaultColumnComponent: DefaultColumnComponent,
    },
    steveAddons: {
        UserFeedback: {
            ModalUserFeedback: ModalUserFeedback.steveAddons,
        },
    },
};
